import { PageContainer, SignTitle } from '@/components'
import { useRequest } from 'ahooks'
import { Card } from 'antd'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import TaskListMain from './task-list-main'
const EmailTaskList: React.FC = () => {
  const { state }: any = useLocation()

  let [listText, setListText] = useState(state?.task_name || '')
  let [random, setRandom] = useState<any>()
  const { run } = useRequest(
    (e): any => {
      setListText((listText = e))
    },
    {
      debounceWait: 300,
      manual: true,
    },
  )
  return (
    <PageContainer>
      <TaskListMain />
    </PageContainer>
  )
}
export default EmailTaskList
const TaskListContainer = styled(Card)`
  min-height: 100%;
  width: 100%;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  border-radius: 8px;
  .flex {
    display: flex;
  }
  .justify-right {
    justify-content: right;
  }
  .ant-card-body {
    display: flex;
    flex-wrap: wrap;
  }
  .ant-input-wrapper {
    width: 230px;
    height: 32px;
    button {
      width: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #2973ff;
      border-radius: 4px !important;
      .anticon-search {
        color: #fff;
      }
    }
  }
`
